import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectNumber = simpleSet as
  redux.reducers.calculationMode.settings.information.projectNumber;

export const projectNumber = setCalculationModeProjectNumber(
  'SET_CALCULATION_MODE_PROJECT_NUMBER',
  ''
);
